import { getWithAuth } from '@/api/httpRequests'
import { getErrorMessage } from '@/shared/lib'
import Config from '@/shared/config/config'
import { ITVServiceToya } from '@/shared/types/services/types/tvService/tvServiceInterfaces'
import {
    getFromLocalStorage,
    removeFromLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'
import { getChannelsRoute } from '@/api/toya/apiConstantsCodespot'
import { ChannelDataType, ChannelType } from '@/shared/types/appTypes'
import { getChannel } from '@/shared/getContainer/getChannel'
import { getConfigRepository } from '@/shared/getContainer/getConfigRepository'

const ConfigRepository = await getConfigRepository()
const configRepository = ConfigRepository.Instance
const Channel = await getChannel()

class TVServiceToya implements ITVServiceToya {
    getFilteredChannelList = (channelsList: ChannelDataType[]) =>
        channelsList.filter((channel: ChannelDataType) => !!channel)

    getChannelObjectList = (channels: ChannelDataType[]) => {
        const channelObjectsList = channels.map((channel: ChannelDataType) => {
            const channelObject = new Channel(channel) as ChannelType
            return channelObject
        })
        return channelObjectsList
    }
    getOttChannels = (channels: ChannelType[]) => {
        const OttChannelsList = channels.filter(
            (channel: ChannelType) => channel.checkOrigin() === 'OTT'
        )
        return OttChannelsList
    }
    getIptvChannels = (channels: ChannelType[]) => {
        const OttChannelsList = channels.filter(
            (channel: ChannelType) => channel.checkOrigin() === 'IPTV'
        )
        return OttChannelsList
    }
    getDvbChannels = (channels: ChannelType[]) => {
        const OttChannelsList = channels.filter(
            (channel: ChannelType) => channel.checkOrigin() === 'DVB'
        )
        return OttChannelsList
    }

    getNoDrmWidevineChannels = (channels: ChannelType[]) => {
        const widevineDrmChannels = channels.filter((channel: ChannelType) => {
            const { drmType } = channel
            return (
                drmType === 'widevine' ||
                drmType === 'noDrm' ||
                drmType === 'drmFairPlay' ||
                drmType === null
            )
        })
        return widevineDrmChannels
    }

    getWidevineOttChannelList = (rawChannels: ChannelDataType[]) => {
        const filteredChannelList = this.getFilteredChannelList(rawChannels)
        const channelObjectList = this.getChannelObjectList(filteredChannelList)
        const ottChannelsList = this.getOttChannels(channelObjectList)
        const filteredNoDrmWidevine =
            this.getNoDrmWidevineChannels(ottChannelsList)

        return filteredNoDrmWidevine
    }

    getApiChannelsList = async () => {
        const token: string | null = getFromLocalStorage(sessionTokenLsKeyword)

        if (!token) return undefined

        try {
            const res = await getWithAuth(getChannelsRoute)

            if (!res) return

            const { response } = res

            const channelsList = response.channels
            if (channelsList) {
                const widevineOttChannelsList =
                    this.getWidevineOttChannelList(channelsList)
                return widevineOttChannelsList
            }
            return
        } catch (error) {
            getErrorMessage('getApiChannelsList', error)
            removeFromLocalStorage(sessionTokenLsKeyword)
        }

        return
    }
    getWidevineOttChannelsIds = (widevineOttChannelsList: ChannelType[]) => {
        const idsArray = widevineOttChannelsList.map(
            (channel: ChannelType) => channel.id
        )
        return idsArray
    }

    getTvChannelsList = (channels: ChannelType[]) => {
        if (!channels) return []
        const tvChannels = channels.filter(
            (channel: ChannelType) => channel.service === 1
        )

        return tvChannels
    }

    getRadioChannelsList = (channels: ChannelType[]) => {
        if (!channels) return []
        const tvChannels = channels.filter(
            (channel: ChannelType) => channel.service === 2
        )
        return tvChannels
    }

    getGroupedTvRadioChannels = (channels: ChannelType[]) => {
        const tvChannels = this.getTvChannelsList(channels)
        const radioChannels = this.getRadioChannelsList(channels)
        return tvChannels.concat(radioChannels)
    }

    checkIfChannelsVersionChanged = async (
        previousLocalConfig: Config | null | undefined
    ) => {
        if (!previousLocalConfig) return false
        const newConfig = configRepository.getLocalConfig()
        if (newConfig) {
            return (
                previousLocalConfig.channelsVersion !==
                newConfig.channelsVersion
            )
        }
    }
    getChannelURL = async (selectedChannel: ChannelType) =>
        new Promise(() => selectedChannel)
    getStreamIQChannelUri = async (selectedChannel: ChannelType) => {
        try {
            return await this.getChannelURL(selectedChannel)
        } catch (error) {
            console.log('error', error)
        }
    }
    loadContent = async (callback: () => void) => {
        try {
            callback()
        } catch (error) {
            getErrorMessage('useShakaPlayer - configPlayer - uri', error)
        }
    }
}

export default new TVServiceToya()
